import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Mail } from "lucide-react";
import { api } from "../lib/api";
import { useCountry } from "../lib/country";
import { useLanguage } from "../lib/language";

export default function Footer() {
    const [settings, setSettings] = useState({});
    const { country } = useCountry();
    const { t } = useLanguage();
    useEffect(() => { api.get("/settings").then(({ data }) => setSettings(data)); }, []);
    const social = settings.social_links || {};
    const socialItems = (settings.social_items || []).filter((it) => it && it.url && it.icon);
    const isUS = country === "US";

    return (
        <footer className="border-t border-[var(--tb-border)] bg-[var(--tb-bg)] mt-24">
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-12">
                <div>
                    <div className="font-display text-2xl mb-3">Terra Boutique</div>
                    <p className="text-sm text-[var(--tb-text-2)] leading-relaxed">
                        {isUS
                            ? t("Lujo accesible para todo Estados Unidos. Curaduría premium, atención personalizada, pagos en USD.", "Accessible luxury across the United States. Premium curation, personal service, USD checkout.")
                            : "Lujo accesible para El Salvador. Curaduría premium, atención personalizada, pagos en USD."}
                    </p>
                    <div className="flex gap-4 mt-6 items-center" data-testid="footer-socials">
                        {socialItems.length > 0 ? (
                            socialItems.map((it, i) => (
                                it.url && it.icon ? (
                                    <a key={it.id || `si-${i}`} href={it.url} target="_blank" rel="noreferrer" title={it.alt || "Red social"} className="tb-link" data-testid={`social-item-${i}`}>
                                        <img src={it.icon} alt={it.alt || "Red social"} className="w-6 h-6 object-contain" />
                                    </a>
                                ) : null
                            ))
                        ) : (
                            <>
                                {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" className="tb-link" data-testid="social-instagram"><Instagram className="w-5 h-5" /></a>}
                                {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" className="tb-link" data-testid="social-facebook"><Facebook className="w-5 h-5" /></a>}
                                {social.whatsapp && <a href={`https://wa.me/${social.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="tb-link" data-testid="social-whatsapp"><MessageCircle className="w-5 h-5" /></a>}
                                <a href="mailto:contacto@terraboutique.com" className="tb-link" data-testid="social-email"><Mail className="w-5 h-5" /></a>
                            </>
                        )}
                    </div>
                </div>
                <div>
                    <div className="tb-overline text-[var(--tb-gold)] mb-4">{t("Tienda", "Shop")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/tienda" className="tb-link">{t("Catálogo", "Catalog")}</Link></li>
                        <li><Link to="/como-usar" className="tb-link">{t("Cómo Comprar", "How to Buy")}</Link></li>
                        <li><Link to="/soporte" className="tb-link">{t("Soporte", "Support")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="tb-overline text-[var(--tb-gold)] mb-4">{t("Legal", "Legal")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/legal/terminos" className="tb-link" data-testid="footer-terminos">{t("Términos y Condiciones", "Terms & Conditions")}</Link></li>
                        <li><Link to="/legal/privacidad" className="tb-link" data-testid="footer-privacidad">{t("Política de Privacidad", "Privacy Policy")}</Link></li>
                        <li><Link to="/legal/seguridad" className="tb-link" data-testid="footer-seguridad">{t("Seguridad", "Security")}</Link></li>
                        <li><Link to="/legal/cumplimiento" className="tb-link" data-testid="footer-cumplimiento">{t("Cumplimiento Legal", "Legal Compliance")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="tb-overline text-[var(--tb-gold)] mb-4">{t("Contacto · Dirección", "Contact · Address")}</div>
                    <ul className="space-y-2 text-sm text-[var(--tb-text-2)] leading-relaxed">
                        {(() => {
                            const addr = isUS ? (settings.address_us || settings.address) : (settings.address_sv || settings.address);
                            if (addr) return <li className="whitespace-pre-line">{addr}</li>;
                            return <li>{isUS ? t("Envíos a todo Estados Unidos", "Shipping across the United States") : "El Salvador, C.A."}</li>;
                        })()}
                        <li className="pt-2">{t("Moneda", "Currency")}: USD ($)</li>
                        {social.whatsapp && <li>WhatsApp: {social.whatsapp}</li>}
                    </ul>
                </div>
            </div>
            <div className="border-t border-[var(--tb-border)] py-6 text-center text-xs text-[var(--tb-muted)]">
                © {new Date().getFullYear()} Terra Boutique. {t("Todos los derechos reservados.", "All rights reserved.")}
            </div>
        </footer>
    );
}
